(function () {
    "use strict";

    if (!Array.prototype.clean) {
        Array.prototype.clean = function () {
            return this.filter(function (item) {
                return item != "";
            });
        };
    }
})();


// WEBPACK FOOTER //
// ./content/js/PrototypeExtensions/Array.clean.js